import React from "react";
import showdown from "showdown";

showdown.setOption("openLinksInNewWindow", true);
const converter = new showdown.Converter({
  literalMidWordUnderscores: true
});

const Markdown = ({ text, className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: converter.makeHtml(text) }}
    />
  );
};

export default Markdown;
